import PendingTasksBoard from '@/components/tasks/PendingTasksBoard';

export default function TasksPage() {
  return (
    <div data-testid="tasks-page">
      <PendingTasksBoard />
    </div>
  );
}
